/**
 * How big a session gets, and how long it waits for somebody to come back.
 *
 * Both numbers are read in several places that have to agree. The cap is checked in the handshake,
 * enforced again by the seat table and shown in the lobby; the hold window is how long the host
 * keeps a seat and how long the guest keeps retrying, and those two drifting apart is a seat that
 * frees a second before its owner walks back into it, or a guest still dialling a chair somebody
 * else already took.
 */

/** Host plus three guests. What one bay is designed and budgeted for. */
export const MAX_PLAYERS = 4;

/** The host is player one. Guests are handed the lowest free number as they arrive. */
export const HOST_PLAYER_ID = 1;

/** The host holds one seat from the moment the session exists. */
export const MAX_GUESTS = MAX_PLAYERS - 1;

/**
 * How long a dropped player's seat is kept, and how long that player keeps trying to get back.
 *
 * Long enough to survive a phone changing cell or a laptop switching to another access point, short
 * enough that nobody stares at a greyed-out row wondering whether the game is broken.
 */
export const SEAT_HOLD_MS = 15_000;
